export const getPromoCodeComponent = () => { 
    return {
      widgets:[ 
        {
          code:'19357',
          name: 'PROMO',
          bundleLink: null,
          bundleCode: null,
          group: 'PROMO',
          groupTitle: '',
          errorMessage: [],
          components:[
            {
              name: 'PromoCode',
              value: '',
              status: [],
              errorMessage: [],
              //validations: {
               // isRequired: true,
                 //default: [
                //   {
                //     validate: VALIDATION_METHODS.filled,
                //     getErrorMessage:VALIDATION_ERRORS.filled
                //   }
                 //]
              //},
              type: 'text',
              componentTitle: 'Inserisci il codice coupon in tuo possesso',
              cleanName: 'Codice coupon',//'PromoCode',
              active:true,
              isDisabled:false
            }
          ],
          active:true,
          status:[]

        }
      ]
      
    }
  }
  
  export const getPromotionalComponent = () => {
    return {
      code: '19358',
      description: '',
      events: {},
      id: 'S16S1D2',
      title: '',
      type: 'LABEL',
      typeValues: [],
      value: ['Se hai utilizzato un coupon promozionale, seleziona la fascia di prezzo che pagherai una volta terminata la promozione.']
    }
  }


// WEBPACK FOOTER //
// ./state/static/promoCodeStatic.js